import { Injectable, InjectionToken, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import {
  ActivatedRouteSnapshot,
  DefaultTitleStrategy,
  RouterStateSnapshot,
} from '@angular/router';

export const PAGE_TITLE_PREFIX = new InjectionToken<string>(
  'VMS_PAGE_TITLE_PREFIX',
);

@Injectable()
export class CustomTitleStrategyService extends DefaultTitleStrategy {
  private readonly titlex: Title;
  private readonly prefix = inject(PAGE_TITLE_PREFIX);

  constructor() {
    const titlex = inject(Title);

    super(titlex);

    this.titlex = titlex;
  }

  override updateTitle(routerState: RouterStateSnapshot): void {
    const title = this.concatTitle(routerState.root, '', ': ');
    if (title) {
      this.title.setTitle(`${this.prefix} ${title}`);
    } else {
      this.title.setTitle(this.prefix);
    }
  }

  // see https://stackoverflow.com/questions/61090224/angular-setting-title-depending-on-activated-route-and-its-parents/73245297#73245297
  private concatTitle(
    route: ActivatedRouteSnapshot,
    title: string,
    separator: string,
  ): string {
    if (!route) return title;

    const sub = route.data ? this.getResolvedTitleForRoute(route) : undefined;
    if (sub && !title.endsWith(` ${separator}${sub}`)) {
      title = `${title} ${separator}${sub}`;
    }

    title = this.concatTitle(route.children[0], title, separator);

    return title;
  }
}
